import { CourierClientOptions } from "./courier-client";

export class Client {

  constructor(public readonly options: CourierClientOptions) { }

}
